import React from 'react';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {Subject} from 'rxjs';
import {distinctUntilChanged, takeUntil} from 'rxjs/operators';
import {inAnteprima, skinCorrente} from '../../skin';
import {eOspite} from '../../utils/currentUser';
import {blocchiHome, fasciaFornitori, impostazione, righeDellaHome, sezioneAccesa, sezioniAccese, sezioniDelleRighe, tuttiIGiochiDellaScheda} from '../../moduli/leggi';
import {useSkin} from '../../moduli/useSkin';
import IconaGioco, {esisteIcona} from '../Header/components/common/IconeGioco';
import {indirizzoImmagine} from '../../utils/immagini';
import ProssimePartite from './ProssimePartite';
import {Gara, Vantaggio, VincendoOra} from './Backend';
import CercaPillole from './CercaPillole';
import Promo from './Promo';
import Fiducia from './Fiducia';
import Nota from './Nota';
import GiochiTop from './GiochiTop';
import GriglieDiGiochi from './GriglieDiGiochi';
import RigaInfinita from './RigaInfinita';
import Copertina from '../Casino/Copertina';
import FasciaFornitori from '../Casino/FasciaFornitori';
import {logoDiSerie} from '../Casino/fornitoriNoti';
import {RigaSegnaposto} from '../Casino/Scheletro';
import {giochi as giochiCasino, giochiPronti, descriviErrore as erroreCasino, recenti as giocatiDiRecente} from '../../services/casinoApi';
import '../Casino/Casino.css';
import './Vetrina.css';

/**
 * LA HOME: la vetrina.
 *
 * E' quello che si vede aprendo il link, e chi apre il link di solito e'
 * SCOLLEGATO: la pagina e' pensata da li'. Da collegato e' la stessa pagina
 * con saldo e nome nella striscia in alto (che e' gia' cosi').
 *
 * Qui NON si compila la schedina: toccando una quota si va in Sport con
 * quella quota gia' dentro. La schedina vive in Sport e, domani, in Live.
 *
 * LA HOME E' UNA LISTA DI BLOCCHI, nell'ordine in cui appaiono: li compone
 * il backoffice per skin (modulo «home», skin.moduli.home.blocchi) e il
 * sito li legge da moduli/leggi.js. Dove la skin non ha scritto niente vale
 * la lista «di serie» del catalogo, che e' la Home com'era prima dei
 * moduli: apertura, banner, live adesso, prossime partite, casino'. Un
 * blocco di una sezione spenta (Sport spento = niente partite) non c'e'.
 *
 * DAL BACKOFFICE PARTE TUTTO: la pagina legge i campi, non se li inventa.
 * Dove un campo non arriva ancora (riga di benvenuto, immagini del banner)
 * si vede il posto vuoto con scritto perche', non un valore di ripiego.
 *
 * LE PAROLE passano da t('…') con la frase italiana come chiave (i18n.js):
 * nelle altre lingue arrivano dal dizionario. Quello che scrive la skin dal
 * backoffice (riga di benvenuto, testo libero, titoli dei blocchi) arriva
 * nella lingua in cui l'ha scritto e si mostra com'e'.
 */
/* La colonna stretta e centrale dei blocchi di giochi (come il riquadro della ricerca): 0 o niente = tutta la pagina. */
const colonnaStretta = (larghezza) => (Number(larghezza) > 0 ? {maxWidth: Number(larghezza) + 'px', marginLeft: 'auto', marginRight: 'auto', width: '100%'} : undefined);

const DISEGNA = {
  sezioni: (b) => <Sezioni titolo={impostazione(b, 'titolo')}/>,
  liveAdesso: () => <LiveAdesso/>,
  prossimePartite: (b) => (
    <ProssimePartite quante={Number(impostazione(b, 'quante')) || 12}
      ogniSecondi={Number(impostazione(b, 'ogniSecondi')) || 5}/>
  ),
  casino: (b) => <Casino quanti={Number(impostazione(b, 'quanti')) || 12} larghezza={impostazione(b, 'larghezza')} categoria={String(impostazione(b, 'categoria') || '').trim()}/>,
  righe: (b, userService) => <RigheDiGiochi scelte={impostazione(b, 'schede')} quanti={Number(impostazione(b, 'quanti')) || 30} larghezza={impostazione(b, 'larghezza')} userService={userService}/>,
  giochiTop: (b) => <GiochiTop titolo={impostazione(b, 'titolo')} scelte={impostazione(b, 'schede')} quanti={Number(impostazione(b, 'quanti')) || 5}/>,
  griglie: (b) => (
    <GriglieDiGiochi scelte={impostazione(b, 'schede')} righe={Number(impostazione(b, 'righe')) || 2}
      colonne={Number(impostazione(b, 'colonne')) || 10} larghezza={Number(impostazione(b, 'larghezza'))}
      mostraDiPiu={impostazione(b, 'mostraDiPiu') !== false}/>
  ),
  fornitori: (b) => (
    <Fornitori titolo={impostazione(b, 'titolo')} loghi={impostazione(b, 'loghi')}/>
  ),
  testo: (b) => <TestoLibero titolo={impostazione(b, 'titolo')} testo={impostazione(b, 'testo')}/>,
  /* I blocchi che aspettano il backend (Backend.js): accesi mostrano lo scheletro, mai numeri inventati. */
  vincendoOra: (b) => <VincendoOra blocco={b}/>,
  vantaggio: (b) => <Vantaggio blocco={b}/>,
  gara: (b) => <Gara blocco={b}/>,
  cercaPillole: (b) => (
    <CercaPillole titolo={impostazione(b, 'titolo')} casella={impostazione(b, 'casella') !== false}
      quante={Number(impostazione(b, 'quante')) || 10} risultati={impostazione(b, 'risultati') !== false}
      iniziale={String(impostazione(b, 'iniziale') || '').trim()} colonne={Number(impostazione(b, 'colonne')) || 10}
      righe={Number(impostazione(b, 'righe')) || 2} larghezza={Number(impostazione(b, 'larghezza'))}
      tipi={impostazione(b, 'tipi') !== false} perFornitore={impostazione(b, 'perFornitore') !== false}/>
  ),
  promo: (b) => <Promo titolo={impostazione(b, 'titolo')} voci={impostazione(b, 'voci')}/>,
  fiducia: (b) => <Fiducia titolo={impostazione(b, 'titolo')} loghi={impostazione(b, 'loghi')}/>,
};

export default function Vetrina({userService}) {
  useSkin();
  const {t} = useTranslation();
  const skin = skinCorrente();
  const navigate = useNavigate();
  const ospite = eOspite();
  const blocchi = blocchiHome();
  const conSport = sezioneAccesa('sport');

  /* Apertura e banner stanno nella stessa riga sul computer quando nella
     lista sono uno dopo l'altro: si disegnano insieme, nel punto del primo
     dei due. Se il backoffice li separa (il banner spostato piu' in basso,
     sotto le righe) ognuno sta al suo posto: prima il banner restava in
     cima, attaccato all'apertura, dovunque lo si mettesse. */
  const iApertura = blocchi.findIndex((b) => b.tipo === 'apertura');
  const iBanner = blocchi.findIndex((b) => b.tipo === 'banner');
  const insieme = iApertura >= 0 && iBanner >= 0 && Math.abs(iApertura - iBanner) === 1;
  let aperturaDisegnata = false;
  const disegnaApertura = (tipo) => {
    if (insieme && aperturaDisegnata) return null;
    aperturaDisegnata = true;
    const apertura = (insieme || tipo === 'apertura') && iApertura >= 0 ? blocchi[iApertura] : null;
    const banner = (insieme || tipo === 'banner') && iBanner >= 0 ? blocchi[iBanner] : null;
    const benvenuto = apertura ? String(impostazione(apertura, 'benvenuto') || '').trim() : '';
    const immagini = banner ? impostazione(banner, 'immagini') : [];
    /* Una voce del banner e' un'immagine o un video (o tutti e due: allora
       l'immagine e' la copertina finche' il video non parte). */
    const voci = Array.isArray(immagini) ? immagini.filter(conFile) : [];
    const conImmagini = voci.length > 0;
    return (
      <section className={'vet-apertura'} aria-label={apertura ? t('Benvenuto') : undefined} key={tipo}>
        {apertura && (
          <div className={'vet-benvenuto'}>
            <h1>{skin && skin.name ? skin.name : (inAnteprima() ? t('[TITOLO DI BENVENUTO DELLA SKIN]') : t('Benvenuto'))}</h1>
            {benvenuto
              ? <p className={'vet-benvenuto-riga'}>{benvenuto}</p>
              : (
                <Nota tono={'spento'}>
                  {t('La riga di benvenuto la scrive la skin dal backoffice (Moduli → Home → Apertura). Oggi non è scritta: si vede il posto, non un testo inventato.')}
                </Nota>
              )}
            <div className={'vet-azioni'}>
              {conSport && (
                <button type={'button'} className={'vet-primario'} onClick={() => navigate('/sport')}>
                  {t('Guarda le quote')}
                </button>
              )}
              {ospite && (
                <span className={'vet-nota piccola'}>
                  {t('Per giocare serve il conto: entra da «Accedi» o, se non ce l’hai, registrati.')}
                </span>
              )}
            </div>
          </div>
        )}
        {/* Senza immagini il posto del banner lo vede solo chi compone la skin. */}
        {banner && (conImmagini ? <Banner immagini={voci}/> : inAnteprima() && (
          <div className={'vet-banner'} role={'img'} aria-label={t('Banner della skin')}>
            <span className={'vet-segnaposto-titolo'}>{t('[BANNER DELLA SKIN · 1 DI 3]')}</span>
            <span className={'vet-segnaposto-testo'}>
              {t('immagine dal backoffice · porta a un evento, un campionato, uno sport o un gioco')}
            </span>
            <span className={'vet-punti'} aria-hidden={'true'}>
              <i className={'acceso'}/><i/><i/>
            </span>
            <Nota tono={'spento'} etichetta={t('da caricare')}>
              {t("Le immagini si caricano dal backoffice (Moduli → Home → Banner). Oggi non ce n'è nessuna: si vede il posto, non un'immagine di ripiego.")}
            </Nota>
          </div>
        ))}
      </section>
    );
  };

  return (
    <div className={'vetrina'}>
      {blocchi.map((b) => {
        if (b.tipo === 'apertura' || b.tipo === 'banner') return disegnaApertura(b.tipo);
        const disegna = DISEGNA[b.tipo];
        return disegna ? <React.Fragment key={b.tipo}>{disegna(b, userService)}</React.Fragment> : null;
      })}
      {blocchi.length === 0 && (
        <Nota tono={'spento'}>
          {t('La Home di questa skin non ha nessun blocco acceso: si accendono dal backoffice (Moduli → Home).')}
        </Nota>
      )}
    </div>
  );
}

/**
 * LE SEZIONI A SCHEDE (il modello «Vetrina a schede», D): una scheda per
 * ogni sezione accesa, con l'icona della riga dei giochi, nell'ordine della
 * riga. Tocca e vai alla pagina della sezione. Sul computer stanno in una
 * riga, sul telefono due per riga: la forma da 390 px e' decisa qui, una
 * volta, non si configura.
 *
 * Quali sezioni: quelle accese sulla skin (sezioniAccese), le stesse della
 * riga in alto e del foglio Giochi. Non si sceglie qui: una sezione spenta
 * non ha scheda. Con nessuna sezione accesa il blocco lo dice.
 */
function Sezioni({titolo}) {
  const navigate = useNavigate();
  const {t} = useTranslation();
  const sezioni = sezioniAccese();
  const intestazione = titolo || t('Le sezioni');
  if (!sezioni.length && !inAnteprima()) return null;
  return (
    <section className={'vet-blocco'} aria-label={intestazione}>
      <div className={'vet-testata'}><h2>{intestazione}</h2></div>
      {sezioni.length === 0 ? (
        <Nota tono={'spento'}>
          {t('Nessuna sezione accesa sulla skin: le schede compaiono quando se ne accende una dal backoffice (Moduli → Sezioni).')}
        </Nota>
      ) : (
        <div className={'vet-sezioni'}>
          {sezioni.map((s) => (
            <button type={'button'} className={'vet-sezione'} key={s.chiave}
              onClick={() => navigate(s.percorso)} aria-label={t('Vai a {{dove}}', {dove: s.nome})}>
              {esisteIcona(s.icona) && <IconaGioco nome={s.icona} className={'vet-sezione-icona'}/>}
              <span className={'vet-sezione-nome'}>{s.nome}</span>
              <span className={'vet-sezione-vai'}>{t('Vai')} &rsaquo;</span>
            </button>
          ))}
        </div>
      )}
    </section>
  );
}

/**
 * TESTO LIBERO: un titolo e un testo scritti dal backoffice (un bonus, un
 * avviso, una presentazione). Gli a capo restano a capo; niente formato.
 * Senza testo si vede il posto vuoto con scritto dove si scrive: nessun
 * testo di ripiego.
 */
function TestoLibero({titolo, testo}) {
  const {t} = useTranslation();
  const intestazione = String(titolo || '').trim();
  const corpo = String(testo || '').trim();
  if (!corpo && !inAnteprima()) return null;
  return (
    <section className={'vet-blocco'} aria-label={intestazione || t('Testo')}>
      {intestazione && <div className={'vet-testata'}><h2>{intestazione}</h2></div>}
      {corpo
        ? <p className={'vet-testo-libero'}>{corpo}</p>
        : (
          <Nota tono={'spento'}>
            {t('Il testo si scrive dal backoffice (Moduli → Home → Testo libero). Oggi non è scritto: si vede il posto, non un testo inventato.')}
          </Nota>
        )}
    </section>
  );
}

/** Una voce del banner che ha qualcosa da mostrare: un'immagine o un video. */
function conFile(i) {
  return Boolean(i && (String(i.indirizzo || '').trim() || String(i.video || '').trim()));
}

/** Chi ha chiesto al sistema meno animazioni: il video non parte da solo. */
function menoMovimento() {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/* CHI RISPARMIA DATI NON SCARICA IL VIDEO DA SOLO. Il video della Home (anche
   5 MB) partiva a ogni apertura anche sul telefono: con «Risparmio dati»
   acceso o su una rete lenta (2G/3G) resta fermo, coi comandi, come per chi
   ha chiesto meno animazioni, e si scarica solo se lo si fa partire. */
function risparmioDati() {
  try {
    const c = typeof navigator !== 'undefined' && navigator.connection;
    return !!c && (c.saveData === true || /(^|-)(2g|3g)$/.test(String(c.effectiveType || '')));
  } catch (e) {
    return false;
  }
}

/**
 * IL BANNER CON LE IMMAGINI DELLA SKIN: una alla volta, i puntini dicono
 * quale, si cambia col tocco sul puntino o da sola ogni otto secondi.
 * Toccando l'immagine (o il suo pulsante) si va dove dice il collegamento
 * (un indirizzo del sito, come /sport o /casino, o esterno). Sopra
 * l'immagine, se scritti, il titolo, una riga e il pulsante.
 *
 * UNA VOCE PUO' ESSERE UN VIDEO (campo «video»): il banner allora va a
 * tutta larghezza in 16:9, sopra l'apertura, e il video parte da solo,
 * muto (i browser fanno partire da soli solo i video muti), in loop se e'
 * l'unica voce; con piu' voci, finito il video si passa alla seguente e i
 * otto secondi non contano. Il pulsantino in basso a destra accende
 * l'audio. Chi ha chiesto meno animazioni vede il video fermo, coi comandi.
 * Titolo, riga e pulsante stanno sempre sopra il video, anche sul telefono.
 */
function Banner({immagini}) {
  const navigate = useNavigate();
  const {t} = useTranslation();
  const [quale, setQuale] = React.useState(0);
  const [audio, setAudio] = React.useState(false);
  const corrente = immagini[Math.min(quale, immagini.length - 1)];
  const video = String(corrente.video || '').trim();
  const conVideo = immagini.some((i) => String(i.video || '').trim());
  const fermo = menoMovimento() || risparmioDati();
  React.useEffect(() => {
    if (immagini.length < 2 || video) return undefined;
    const t = setInterval(() => setQuale((q) => (q + 1) % immagini.length), 8000);
    return () => clearInterval(t);
  }, [immagini.length, video]);
  const avanti = () => setQuale((q) => (q + 1) % immagini.length);
  /* «muted» va messo sull'elemento, non solo come attributo di React: senza,
     Safari sul telefono non fa partire il video da solo. */
  const filmato = React.useRef(null);
  React.useEffect(() => {
    const el = filmato.current;
    if (!el || fermo) return;
    el.muted = !audio;
    const p = el.play();
    if (p && typeof p.catch === 'function') p.catch(() => {});
  }, [video, audio, fermo]);
  /* Titolo, riga e pulsante sopra l'immagine: li scrive il backoffice
     (Moduli › Home › Banner), uno per immagine. Vuoti, l'immagine e' sola. */
  const titolo = String(corrente.titolo || '').trim();
  const riga = String(corrente.testo || '').trim();
  const pulsante = String(corrente.pulsante || '').trim();
  const vai = () => {
    const dove = String(corrente.collegamento || '').trim();
    if (!dove) return;
    if (/^https?:\/\//i.test(dove)) window.open(dove, '_blank', 'noopener');
    else navigate(dove);
  };
  return (
    <div className={'vet-banner pieno' + (conVideo ? ' con-video' : '')} role={'group'} aria-label={t('Banner della skin')}>
      <div className={'vet-banner-quadro'}>
        {video ? (
          <div className={'vet-banner-schermo'}>
            {fermo ? (
              <video key={video} className={'vet-banner-filmato'} src={indirizzoImmagine(video)}
                poster={corrente.indirizzo ? indirizzoImmagine(corrente.indirizzo) : undefined}
                controls playsInline preload={'metadata'}/>
            ) : (
              <button type={'button'} className={'vet-banner-immagine'} onClick={vai}
                aria-label={titolo || (corrente.collegamento ? t('Apri {{dove}}', {dove: corrente.collegamento}) : t('Banner'))}>
                <video key={video} ref={filmato} className={'vet-banner-filmato'} src={indirizzoImmagine(video)}
                  poster={corrente.indirizzo ? indirizzoImmagine(corrente.indirizzo) : undefined}
                  autoPlay muted={!audio} loop={immagini.length < 2} playsInline preload={'auto'}
                  onEnded={avanti} aria-hidden={'true'}/>
              </button>
            )}
            {!fermo && (
              <button type={'button'} className={'vet-banner-audio'} onClick={() => setAudio((a) => !a)}
                aria-pressed={audio} aria-label={audio ? t('Spegni l’audio') : t('Accendi l’audio')}>
                <svg viewBox={'0 0 24 24'} width={18} height={18} aria-hidden={'true'}>
                  <path d={'M4 9h4l5-4v14l-5-4H4z'} fill={'currentColor'}/>
                  {audio
                    ? <path d={'M16 8.5a5 5 0 0 1 0 7M18.5 6a8.5 8.5 0 0 1 0 12'} fill={'none'} stroke={'currentColor'} strokeWidth={2} strokeLinecap={'round'}/>
                    : <path d={'M16 9.5l5 5M21 9.5l-5 5'} fill={'none'} stroke={'currentColor'} strokeWidth={2} strokeLinecap={'round'}/>}
                </svg>
              </button>
            )}
          </div>
        ) : (
          <button type={'button'} className={'vet-banner-immagine'} onClick={vai}
            aria-label={titolo || (corrente.collegamento ? t('Apri {{dove}}', {dove: corrente.collegamento}) : t('Banner'))}>
            <img src={indirizzoImmagine(corrente.indirizzo)} alt={''}/>
          </button>
        )}
        {(titolo || riga || pulsante) && (
          <div className={'vet-banner-testi'}>
            {titolo && <h2>{titolo}</h2>}
            {riga && <p>{riga}</p>}
            {pulsante && <button type={'button'} className={'vet-primario'} onClick={vai}>{pulsante}</button>}
          </div>
        )}
      </div>
      {immagini.length > 1 && (
        <span className={'vet-punti'}>
          {immagini.map((i, n) => (
            <i key={n} className={n === quale ? 'acceso' : ''} role={'button'} tabIndex={0}
              aria-label={t('Immagine {{numero}}', {numero: n + 1})} onClick={() => setQuale(n)}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') setQuale(n); }}/>
          ))}
        </span>
      )}
    </div>
  );
}

/**
 * LIVE ADESSO.
 *
 * COSA FA (quando ci sara'): le partite in corso con minuto, punteggio e
 * quote che si muovono - la freccia accanto alla quota dice se e' salita o
 * scesa (colore E freccia, mai il colore da solo), «sosp.» e' un mercato
 * sospeso che non si tocca. Sta sopra al resto dello sport perche', quando
 * c'e', e' la cosa piu' urgente. Toccando si va alla pagina Live dell'evento.
 *
 * COSA NON FA: non mostra tutte le partite in corso (il numero di righe lo
 * decidera' la skin), e non si gioca da qui.
 *
 * OGGI E' SPENTO: il live non esiste. Mancano, in ordine: un fornitore col
 * feed live; il sito che RICEVE i cambi di quota senza ricaricare (oggi
 * ricarica solo al cambio pagina); minuto e punteggio sull'evento nel
 * catalogo. Le righe qui sotto sono un ESEMPIO della forma, non dati.
 */
function LiveAdesso() {
  const {t} = useTranslation();
  /* Partite d'esempio: a chi gioca sembrerebbero vere. Le vede solo l'anteprima. */
  if (!inAnteprima()) return null;
  const sospesa = t('sosp.');
  const esempio = [
    {tempo: "67'", punti: '1 – 0', evento: t('Squadra A — Squadra B'), lega: t('Calcio · Campionato'),
      quote: [['1', '1.45', 'giu'], ['X', '4.20', 'su'], ['2', '8.50', 'su']]},
    {tempo: "23'", punti: '0 – 0', evento: t('Squadra C — Squadra D'), lega: t('Calcio · Campionato'),
      quote: [['1', '2.60', ''], ['X', sospesa, ''], ['2', '2.75', '']]},
    {tempo: t('2° set'), punti: '1 – 0', evento: t('Giocatore E — Giocatore F'), lega: t('Tennis · Torneo'),
      quote: [['1', '2.10', 'su'], ['2', '1.72', 'giu']]},
  ];
  return (
    <section className={'vet-blocco spento'} aria-label={t('Live adesso')}>
      <div className={'vet-testata'}>
        <span className={'vet-pallino-live'} aria-hidden={'true'}/>
        <h2>{t('Live adesso')}</h2>
        <span className={'vet-etichetta'}>{t('da collegare · oggi spento')}</span>
      </div>
      <Nota tono={'spento'}>
        {t("Il live non esiste ancora. Servono: un fornitore col feed live; il sito che riceve i cambi di quota senza ricaricare; minuto e punteggio sull'evento nel catalogo. Le righe sotto sono un esempio della forma, non partite vere. Non si gioca da qui: toccando si andrà alla pagina Live dell'evento.")}
      </Nota>
      <div className={'vet-live-righe'} aria-hidden={'true'}>
        {esempio.map((r) => (
          <div className={'vet-live-riga'} key={r.evento}>
            <span className={'vet-live-tempo'}>{r.tempo}</span>
            <span className={'vet-live-punti'}>{r.punti}</span>
            <div className={'vet-live-evento'}>
              <span className={'vet-nome'}>{r.evento}</span>
              <span className={'vet-lega'}>{r.lega}</span>
            </div>
            <div className={'vet-quote'}>
              {r.quote.map(([segno, q, verso]) => (
                <span className={'lvc-cella lvc-quota' + (q === sospesa ? ' lvc-chiusa' : '')} key={segno}>
                  <span className={'vet-segno'}>{segno}</span>
                  <span className={'vet-valore'}>
                    {verso === 'su' && <i className={'vet-verso su'}>▲</i>}
                    {verso === 'giu' && <i className={'vet-verso giu'}>▼</i>}
                    {q}
                  </span>
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

/* Gli elenchi gia' in memoria (si torna alla Home, si cambia pagina): le
   righe si disegnano piene subito, senza scheletro. null se ne manca uno. */
function elenchiPronti(chiave) {
  const coppie = chiave.split(',').filter(Boolean).map((x) => [x, giochiPronti(x)]);
  return coppie.every(([, e]) => e) ? {carica: false, errore: '', elenchi: Object.fromEntries(coppie)} : null;
}

/**
 * CASINO'.
 *
 * Una riga di giochi del casino', presi dal fornitore attraverso
 * casino-service: i primi `quanti` della `categoria` scelta dal backoffice
 * (vuota: i primi dell'elenco, nell'ordine del fornitore), con «Vedi tutti»
 * che porta alla lobby. Compare SOLO se la sezione casino' e' accesa.
 * Toccando un gioco si va nella sua pagina: da scollegati li' si apre la
 * finestra di accesso.
 *
 * Non inventa giochi: se casino-service non risponde lo dice, con codice e
 * dettaglio.
 */
function Casino({quanti, categoria, larghezza}) {
  const {t} = useTranslation();
  const navigate = useNavigate();
  /* Con l'elenco gia' in memoria la riga si disegna piena al primo colpo. */
  const [stato, setStato] = React.useState(() => {
    const pronti = giochiPronti('casino');
    return pronti ? {carica: false, errore: '', elenco: pronti} : {carica: true, errore: '', elenco: []};
  });
  React.useEffect(() => {
    let vivo = true;
    giochiCasino('casino')
        .then((elenco) => vivo && setStato({carica: false, errore: '', elenco}))
        .catch((e) => vivo && setStato({carica: false, errore: erroreCasino(e), elenco: []}));
    return () => { vivo = false; };
  }, []);
  const scelti = stato.elenco
      .filter((g) => !categoria || g.categorie.includes(categoria))
      .slice(0, quanti);
  return (
    <section className={'vet-blocco'} aria-label={t('Casinò')} style={colonnaStretta(larghezza)}>
      <div className={'vet-testata'}>
        <h2>{categoria || t('Casinò')}</h2>
        <div className={'vet-testata-dx'}>
          <button type={'button'} className={'vet-link'} onClick={() => navigate('/casino')}>{t('Vedi tutti')}</button>
        </div>
      </div>
      {stato.carica && <RigaSegnaposto quanti={6} className={'vet-casino'} inArrivo/>}
      {stato.errore && (
        <Nota tono={'errore'}>{stato.errore}</Nota>
      )}
      {!stato.carica && !stato.errore && !scelti.length && <Nota tono={'spento'} giocatore={t('Non ci sono giochi da mostrare per ora.')}>{t('Il fornitore non ha giochi per questa sezione.')}</Nota>}
      {!stato.carica && !scelti.length && <RigaSegnaposto quanti={6} className={'vet-casino'}/>}
      {scelti.length > 0 && (
        <RigaInfinita className={'vet-casino cas-scorre'}
          figli={scelti.map((g) => <Copertina key={g.id} gioco={g} onApri={() => navigate('/casino/gioco/' + encodeURIComponent(g.id))}/>)}/>
      )}
    </section>
  );
}

/**
 * RIGHE DI GIOCHI: una riga per ogni voce scelta nel blocco (impostazione
 * «schede»), nell'ordine della lista: una scheda del casino' («casino:top10»,
 * la stessa della lobby) o una categoria solo della Home, coi giochi scelti
 * nel blocco anche di Casinò e Live casino insieme (vedi righeDellaHome).
 * Lista vuota: tutte le schede accese, prima Casinò poi Live casino. Ogni
 * riga mostra i primi giochi della sua scheda, quanti dice `quanti` (da 5 a
 * 10), nell'ordine della scheda. Il NOME DELLA RIGA e «Vedi tutti» aprono la
 * pagina della categoria, con TUTTI i suoi giochi a pagine: la lobby sulla
 * scheda (/casino?scheda=top10) o, per una categoria della Home, la sua
 * pagina (/categoria/<id>, PaginaCategoria.js).
 *
 * I giochi sono quelli della scheda (scelti nel backoffice) fra quelli che il
 * fornitore manda per questa skin: uno che non c'e' piu' si salta. Una
 * scheda senza giochi ha la riga a vuoto, con scritto dove si scelgono; una
 * scheda di una sezione spenta non c'e'.
 *
 * DA COLLEGATI, se il giocatore ha gia' aperto dei giochi, la PRIMA riga
 * diventa «Giocati di recente»: gli ultimi aperti col conto, salvati sul conto
 * da casino-service (vedi casinoApi.recenti), quindi chi esce e rientra
 * ritrova gli stessi. Da scollegati, o senza recenti, resta la prima scheda.
 * All'accesso e all'uscita la riga si rilegge senza cambiare pagina.
 */
/* Quanti giochi nella riga «Giocati di recente»: tutti quelli che tiene il conto. */
const QUANTI_RECENTI = 20;

/* Vero da collegati; cambia all'accesso e all'uscita, senza ricaricare la pagina. */
function useCollegato(userService) {
  const [collegato, setCollegato] = React.useState(() => !eOspite());
  React.useEffect(() => {
    if (!userService || typeof userService.isLoggedIn !== 'function') return undefined;
    const stop = new Subject();
    userService.isLoggedIn().pipe(distinctUntilChanged(), takeUntil(stop))
        .subscribe(() => setCollegato(!eOspite()));
    return () => { stop.next(); stop.complete(); };
  }, [userService]);
  return collegato;
}

function RigheDiGiochi({scelte, quanti, larghezza, userService}) {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const sezioni = sezioniDelleRighe();
  const lista = righeDellaHome(scelte, sezioni);
  const collegato = useCollegato(userService);
  const conRecenti = collegato && lista.length > 0;
  /* Il conto risponde a parte: se non risponde la Home resta con le sue righe. */
  const [ricordati, setRicordati] = React.useState([]);
  React.useEffect(() => {
    let vivo = true;
    setRicordati([]);
    if (conRecenti) {
      giocatiDiRecente()
          .then((elenco) => vivo && setRicordati(elenco.filter((r) => sezioni.includes(r.sezione))))
          .catch(() => vivo && setRicordati([]));
    }
    return () => { vivo = false; };
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [conRecenti, sezioni.join(',')]);
  const servono = Array.from(new Set(lista.flatMap((r) => (r.sezione === 'home' ? r.scheda.servono : [r.sezione])).concat(ricordati.map((r) => r.sezione))));
  const chiave = servono.join(',');
  const [stato, setStato] = React.useState(() => elenchiPronti(chiave) || {carica: true, errore: '', elenchi: {}});
  React.useEffect(() => {
    let vivo = true;
    setStato((prima) => elenchiPronti(chiave) || (prima.carica ? prima : {carica: true, errore: '', elenchi: {}}));
    Promise.all(chiave.split(',').filter(Boolean).map((k) => giochiCasino(k).then((elenco) => [k, elenco])))
        .then((coppie) => vivo && setStato({carica: false, errore: '', elenchi: Object.fromEntries(coppie)}))
        .catch((e) => vivo && setStato({carica: false, errore: erroreCasino(e), elenchi: {}}));
    return () => { vivo = false; };
  }, [chiave]);

  /* I recenti che il fornitore manda ancora, nell'ordine in cui sono stati aperti. */
  const recentiTrovati = stato.carica ? [] : ricordati
      .map((r) => ({sezione: r.sezione, gioco: (stato.elenchi[r.sezione] || []).find((g) => g.id === r.id)}))
      .filter((r) => r.gioco)
      .slice(0, QUANTI_RECENTI);

  if (!lista.length) {
    if (!inAnteprima()) return null;
    return (
      <section className={'vet-blocco'} aria-label={t('Righe di giochi')}>
        <Nota tono={'spento'}>
          {t('Nessuna riga da mostrare: si scelgono dal backoffice (Moduli › Home › Righe di giochi), fra le schede di Casinò e Live casino o come categorie solo della Home.')}
        </Nota>
      </section>
    );
  }
  return (
    <>
      {stato.errore && (
        <Nota tono={'errore'}>{stato.errore}</Nota>
      )}
      {recentiTrovati.length > 0 && (
        <section className={'vet-blocco'} aria-label={t('Giocati di recente')} style={colonnaStretta(larghezza)}>
          <div className={'vet-testata'}>
            <h2>{'🕘 ' + t('Giocati di recente')}</h2>
          </div>
          <div className={'vet-casino cas-scorre'}>
            {recentiTrovati.map(({sezione, gioco}) => (
              <Copertina key={sezione + ':' + gioco.id} gioco={gioco}
                onApri={() => navigate((sezione === 'liveCasino' ? '/live-casino' : '/casino') + '/gioco/' + encodeURIComponent(gioco.id))}/>
            ))}
          </div>
        </section>
      )}
      {(recentiTrovati.length > 0 ? lista.slice(1) : lista).map(({sezione, scheda}) => {
        const percorso = sezione === 'liveCasino' ? '/live-casino' : '/casino';
        /* Una categoria della Home prende i giochi da piu' sezioni: ognuno si apre nella sua. */
        const elenchi = (sezione === 'home' ? scheda.servono : [sezione]).map((k) => [k, stato.elenchi[k] || []]);
        const giochi = tuttiIGiochiDellaScheda(scheda, elenchi.flatMap(([, elenco]) => elenco)).slice(0, Math.min(60, Math.max(5, quanti)));
        const apri = (g) => {
          const k = (elenchi.find(([, elenco]) => elenco.includes(g)) || [sezione])[0];
          navigate((k === 'liveCasino' ? '/live-casino' : '/casino') + '/gioco/' + encodeURIComponent(g.id));
        };
        /* La pagina della categoria: la scheda nella lobby, o la pagina di una categoria della Home. */
        const apriTutti = () => navigate(sezione === 'home'
          ? '/categoria/' + encodeURIComponent(scheda.id)
          : percorso + '?scheda=' + encodeURIComponent(scheda.id));
        /* Una riga ancora senza giochi la vede solo chi compone la skin. */
        if (!stato.carica && !stato.errore && !giochi.length && !inAnteprima()) return null;
        return (
          <section className={'vet-blocco'} aria-label={scheda.nome} key={sezione + ':' + scheda.id} style={colonnaStretta(larghezza)}>
            <div className={'vet-testata'}>
              <h2>
                <button type={'button'} className={'cas-riga-nome'} onClick={apriTutti}>
                  {scheda.icona ? scheda.icona + ' ' : ''}{scheda.nome}
                </button>
              </h2>
              <div className={'vet-testata-dx'}>
                <button type={'button'} className={'vet-link'} onClick={apriTutti}>{t('Vedi tutti')}</button>
              </div>
            </div>
            {stato.carica && <RigaSegnaposto quanti={6} className={'vet-casino'} inArrivo/>}
            {!stato.carica && !stato.errore && !giochi.length && (
              <Nota tono={'spento'}>
                {sezione === 'home'
                  ? t('La categoria «{{nome}}» non ha ancora giochi: si scelgono dal backoffice (Moduli › Home › Righe di giochi).', {nome: scheda.nome})
                  : t('La scheda «{{nome}}» non ha ancora giochi: si scelgono dal backoffice (Moduli › {{sezione}} › Schede).', {nome: scheda.nome, sezione: sezione === 'liveCasino' ? t('Live casino') : t('Casinò')})}
              </Nota>
            )}
            {!stato.carica && !giochi.length && <RigaSegnaposto quanti={6} className={'vet-casino'}/>}
            {giochi.length > 0 && (
              <RigaInfinita className={'vet-casino cas-scorre'}
                figli={giochi.map((g) => <Copertina key={g.id} gioco={g} onApri={() => apri(g)}/>)}/>
            )}
          </section>
        );
      })}
    </>
  );
}

/**
 * I FORNITORI: i loghi in fila sotto le righe di giochi, che scorrono da
 * soli e si fermano sotto il mouse o il dito; poi si scorrono a mano (col
 * dito, col trackpad, con la rotella, trascinando col mouse): e' la fascia
 * della lobby (FasciaFornitori.js). I loghi li carica il
 * backoffice (Moduli › Home › Fornitori), ognuno col nome e, se serve, dove
 * porta; senza «Porta a» il logo apre la lobby del Casinò filtrata per quel
 * fornitore.
 *
 * Senza loghi caricati si vedono i NOMI dei fornitori che mandano giochi
 * (dall'elenco di casino-service), non loghi inventati; senza nemmeno
 * quelli, il posto vuoto con scritto dove si caricano.
 */
function Fornitori({titolo, loghi}) {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const caricati = (Array.isArray(loghi) ? loghi : [])
      .filter((l) => l && (String(l.indirizzo || '').trim() || String(l.nome || '').trim()));
  const [nomi, setNomi] = React.useState([]);
  React.useEffect(() => {
    if (caricati.length || !sezioneAccesa('casino')) return undefined;
    let vivo = true;
    giochiCasino('casino')
        .then((elenco) => vivo && setNomi(Array.from(new Set(elenco.map((g) => g.fornitore).filter(Boolean))).sort()))
        .catch(() => vivo && setNomi([]));
    return () => { vivo = false; };
  }, [caricati.length]);
  /* Un fornitore caricato senza immagine, o un nome preso dai giochi, prende
     la scritta di serie se e' un fornitore noto (fornitoriNoti.js). */
  const voci = caricati.length
    ? caricati.map((l) => ({nome: String(l.nome || '').trim(), immagine: String(l.indirizzo || '').trim() || logoDiSerie(l.nome), dove: String(l.collegamento || '').trim()}))
    : nomi.map((n) => ({nome: n, immagine: logoDiSerie(n), dove: ''}));
  const apri = (v) => {
    if (v.dove) {
      if (/^https?:\/\//i.test(v.dove)) window.open(v.dove, '_blank', 'noopener');
      else navigate(v.dove);
    } else if (v.nome) {
      navigate('/casino?fornitore=' + encodeURIComponent(v.nome));
    }
  };
  const intestazione = String(titolo || '').trim() || t('I nostri fornitori');
  if (!voci.length) {
    if (!inAnteprima()) return null;
    return (
      <section className={'vet-blocco'} aria-label={intestazione}>
        <div className={'vet-testata'}><h2>{intestazione}</h2></div>
        <Nota tono={'spento'}>{t('I loghi dei fornitori si caricano dal backoffice (Moduli › Home › Fornitori). Oggi non ce ne sono: si vede il posto, non un logo inventato.')}</Nota>
      </section>
    );
  }
  return (
    <section className={'vet-blocco'} aria-label={intestazione}>
      <div className={'vet-testata'}><h2>{intestazione}</h2></div>
      <FasciaFornitori voci={voci} onScegli={apri} etichetta={intestazione} className={'vet-fornitori'} marquee {...fasciaFornitori()}/>
    </section>
  );
}
